import {Component, Input, OnInit} from '@angular/core';
import {LayoutService} from '../layout.service';
import {AppCommunicationService} from '../../../+app-custom/services/app-communication.service';
import {Router} from '@angular/router';
import {PublicationService} from '../../../+app-custom/services/publication.service';
import {SYSTEM_NAME_AUTH} from '../../../+app-custom/constants';
import {getBaseFrontendUrl} from '../../../+app-custom/app.urls';

@Component({
    selector: 'app-sa-navigation',
    templateUrl: './navigation.component.html'
})

export class NavigationComponent implements OnInit {
    roleOfUser = 0;
    countNewApply =0 ;
    constructor(
        private layoutService: LayoutService,
        private _appCommunicationService: AppCommunicationService,
        private router: Router,
        private publicationService:PublicationService
    ) {
    }

    ngOnInit() {
        this.roleOfUser = this._appCommunicationService.getRoleOfLoggedUser();
        this.publicationService.getNewPublicaitonCount()
            .subscribe((respons:number)=> {this.countNewApply=respons;},(err)=>console.error(err));
    }

    toggleShortcut() {
        this.layoutService.onShortcutToggle()
    }

    navigate(route) {
        this.router.navigate([route]);
    }


    goToCategories() {
        const url = getBaseFrontendUrl(SYSTEM_NAME_AUTH);
        window.open(url, '_self');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts